<template>
  <svg
    width="30"
    height="28"
    viewBox="0 0 30 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26 22H5V5C5 4.73478 4.89464 4.48043 4.70711 4.29289C4.51957 4.10536 4.26522 4 4 4C3.73478 4 3.48043 4.10536 3.29289 4.29289C3.10536 4.48043 3 4.73478 3 5V23C3 23.2652 3.10536 23.5196 3.29289 23.7071C3.48043 23.8946 3.73478 24 4 24H26C26.2652 24 26.5196 23.8946 26.7071 23.7071C26.8946 23.5196 27 23.2652 27 23C27 22.7348 26.8946 22.4804 26.7071 22.2929C26.5196 22.1054 26.2652 22 26 22Z"
      :fill="fill"
    />
    <path
      d="M23.29 7.28977L17 13.5898L13.71 10.2898C13.5227 10.1035 13.2692 9.99898 13.005 9.99898C12.7408 9.99898 12.4874 10.1035 12.3 10.2898L6.30001 16.2898C6.19533 16.3794 6.11031 16.4897 6.05029 16.6138C5.99026 16.7379 5.95653 16.873 5.95122 17.0107C5.9459 17.1484 5.9691 17.2858 6.01938 17.4141C6.06965 17.5424 6.14591 17.659 6.24336 17.7564C6.34082 17.8539 6.45737 17.9301 6.58569 17.9804C6.71402 18.0307 6.85135 18.0539 6.98907 18.0486C7.12679 18.0433 7.26192 18.0095 7.38598 17.9495C7.51005 17.8895 7.62037 17.8045 7.71001 17.6998L13 12.4098L16.29 15.6998C16.4774 15.886 16.7308 15.9906 16.995 15.9906C17.2592 15.9906 17.5127 15.886 17.7 15.6998L24.7 8.69977C24.8638 8.50847 24.9494 8.2624 24.9397 8.01072C24.93 7.75904 24.8257 7.5203 24.6476 7.34221C24.4695 7.16412 24.2307 7.05978 23.9791 7.05006C23.7274 7.04034 23.4813 7.12595 23.29 7.28977Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  name: 'RouteMenuIcon',
  props: {
    fill: {
      default: '#474B6D',
      type: String,
    },
  },
};
</script>